import './bootstrap';
import {createRoot} from 'react-dom/client';
import {createInertiaApp} from '@inertiajs/react'
import i18n from "i18next";
import {initReactI18next} from 'react-i18next';
import translationResources from './translations.js';
import "yet-another-react-lightbox/styles.css";
import "yet-another-react-lightbox/plugins/captions.css";
import "yet-another-react-lightbox/plugins/thumbnails.css";
const appName = import.meta.env.VITE_APP_NAME || 'Lense';


createInertiaApp({
    title: (title) => `${title} - ${appName}`,
    resolve: name => {
        const pages = import.meta.glob('./Pages/**/*.jsx', {eager: true})
        return pages[`./Pages/${name}.jsx`]
    }, setup({el, App, props}) {
        i18n
            .use(initReactI18next) // passes i18n down to react-i18next
            .init({
                resources: translationResources,
                lng: props.initialPage.props.locale,
                fallbackLng: "en",

                interpolation: {
                    escapeValue: false // react already safes from xss => https://www.i18next.com/translation-function/interpolation#unescape
                }
            });
        const root = createRoot(el);


        root.render(
            <App {...props} />);
    },
    progress: {
        color: '#4B5563',
    },
});
